import moment from 'moment';

import { BUSINESS_OWNER_GROUP_NAME, ROLE_BUSINESS_OWNER } from 'constants/auth';
import { groupNameToGroupDisplay, getUserGroups } from 'constants/user';
import { doesUserHaveBusinessRole, isAdminUser, isUserInGroup } from 'libs/auth';

const externalDateTimeFormat = 'MM/DD/YYYY';
const internalDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

const roleLabelMap = {
  ...groupNameToGroupDisplay,
  admin: 'Fisherman Admin',
};

export function canManageUsers(user, business) {
  if (!user || !business) {
    return false;
  }

  if (isAdminUser(user)) {
    return true;
  }

  return (
    doesUserHaveBusinessRole(business, ROLE_BUSINESS_OWNER) ||
    isUserInGroup(user, BUSINESS_OWNER_GROUP_NAME)
  );
}

export function getGroupLabels(user) {
  if (isAdminUser(user)) {
    return [roleLabelMap.admin];
  }

  return getUserGroups(user).map((role) => roleLabelMap[role]);
}

export function getFormattedDateTime(dateTime) {
  if (!dateTime) {
    return '';
  }

  return moment(dateTime, internalDateTimeFormat).format(externalDateTimeFormat);
}
